(function () {
    'use strict';

    (() => {
      document.getElementById('sort-by').addEventListener('change', e => {
        const sortBy = e.target.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy);
        url.searchParams.delete('page');
        window.location.href = url;
      });
    })();

})();
